export interface ICancelMeetingData {
    meetingSk?: string;
    reason?: { id?: number };
    otherReason?: string;
}

export class SubmitCancelMeetingModel {
    meetingSk: string;
    reason: number;
    otherReason: string;
    constructor(data: Partial<ICancelMeetingData>) {
        this.meetingSk = data?.meetingSk;
        this.reason = data?.reason?.id;
        this.otherReason = data?.otherReason;
    }
    get id(): string {
        return this.meetingSk;
    }
}